<template>
    <ui-sidepage extra-large :close="() => closeMe(close)" :title='`${estimate.reference} • ${estimate.title}`'
                 :subtitle="``" :go-transparent="true" v-if="estimate">
        <label class="my-0 py-0 m-0">Send Estimate</label>
        <div class="mt-2 mb-8">
            <estimate-existing-users-search :estimate="estimate" #default="{ close, open, query, setQuery }"
                                            @selected:knownContact="applyKnown"
                                            v-if="estimate.sendLog && estimate.sendLog.length"
            >
                <ui-input label="Send to" v-model="to"
                          :key="inputRenderKey"
                          placeholder="Email address/phone number (multiple separated with commas)..."
                          class="xl:col-span-12"
                          @input="error = false;setQuery(to)"
                          @focus="error = false;setQuery(to);open()"
                ></ui-input>
            </estimate-existing-users-search>
            <ui-input label="Send to" v-model="to" v-else
                      :key="inputRenderKey"
                      placeholder="Email address/phone number (multiple separated with commas)..."
                      class="xl:col-span-12"
                      @input="error = false"
                      @focus="error = false"
            ></ui-input>
            <div class="text-red-600 text-sm pt-1 pb-1 ml-3" v-if="error" v-text="error"></div>
            <label class="block text-sm font-medium text-gray-700 mb-1 mt-2">Message to include</label>
            <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                    ref="autoresizable-message"
            >
                    <textarea
                        placeholder="Message..."
                        class="text-sm m-0 px-2.5 pt-2 pb-2 placeholder-gray-400 rounded-md shadow-sm border border-gray-300 shadow-none relative focus:ring-brand focus:z-20 resize-none"
                        type="text"
                        ref="message"
                        v-model="message"
                    ></textarea>
            </autoresizable-textarea>
            <div class="flex flex-col md:flex-row flex-wrap m-2">
                <div class="flex-1 mt-3.5 pt-2 mr-3 warning text-yellow-600 text-sm text-right">
                    <template v-if="!estimate.readonly">
                        <strong>Warning</strong> - This will lock the estimate to read-only
                    </template>
                </div>
                <ui-button-new primary class="whitespace-nowrap mt-4 mr-2" :loading="busy" @click="send"
                               v-text="'Send'"></ui-button-new>
            </div>
        </div>
        <send-log :send-log="combineSendLogs" @revoke="revoke" @resend="resend" :key="sentLogKey"
                  v-if="this.estimate.sendLog"></send-log>
    </ui-sidepage>
</template>

<script>
import UiSidepage from "../../../ui/UiSidepage.vue";
import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import UiDropdownItem from "../../../ui/UiDropdownItem.vue";
import UiDropdown from "../../../ui/UiDropdown.vue";
import moment from "moment";
import UiInput from "../../../ui/UiInput.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiDataGridItem from "../../../ui/UiDataGridItem.vue";
import UiButtonNew from "../../../ui/UiButtonNew.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";
import UiDropdownDivider from "../../../ui/UiDropdownDivider.vue";
import SendLog from "../../../send-log/SendLog.vue";
import EstimateExistingUsersSearch from "./EstimateExistingUsersSearch.vue";
import {PackageNew} from "@models";
import PageCell from "../../../ui/PageCell.vue";
import PurchaseOrderResolvePOToRFMsItemSelect
    from "../../../procurement/purchase-orders/PurchaseOrderResolvePOToRFMsItemSelect.vue";

export default {
    components: {
        PurchaseOrderResolvePOToRFMsItemSelect,
        PageCell,
        SendLog,
        UiDropdownDivider,
        UiFormSection,
        UiButtonNew,
        UiDataGridItem,
        UiTextarea, UiInput,
        UiDropdown, UiDropdownItem,
        AutoresizableTextarea,
        EstimateExistingUsersSearch,
        UiSidepage
    },
    props: {
        item: Object,
        close: Function,
    },
    watch: {},
    computed: {
        combineSendLogs() {
            return this.estimate.sendLog.map((a) => {
                return a;
            }).sort((a, b) => moment(b.requested.at).unix() - moment(a.requested.at).unix())
        }
    },
    data() {
        return {
            email: '',
            estimate: Object,
            error: '',
            moment: moment,
            busy: false,
            closed: false,
            to: '',
            message: '',
            sentLogKey: 0,
            inputRenderKey: 0
        }
    },
    methods: {
        applyKnown(contact) {
            this.to = contact;
            this.inputRenderKey++
        },
        revoke(i) {
            this.estimate.revoke(i.id);
        },
        resend(i) {
            this.estimate.resend(i.id);
        },
        closeMe(close) {
            this.closed = true
            if (this.reloading) {
                clearTimeout(this.reloading)
            }
            close()
        },
        async send() {
            this.busy = true;
            let response = await this.estimate.send(this.to, this.message)
            if (response.status !== 'ok') {
                if (response.data.message.startsWith('Invalid email')) {
                    this.error = 'ERROR: Cannot determine how to handle "' + this.to + '" - is this a valid email address or phone number?'
                }
            } else {
                await this.estimate.reload()
                this.to = ''
                this.message = ''
                this.sentLogKey++;

                // update to quoted
                let p = await PackageNew.find(this.estimate.packageReference)
                if (p.status === 'Quoting' || p.status === 'New Enquiry') {
                    this.$modals.confirm({
                        title: `Do you want to update this Package to "Quoted"?`,
                        button: 'Yes, update the Package',
                        paragraphs: ['This will update this estimates "Package" and then reload the page.'],
                        handle: async () => {
                            let p = await PackageNew.find(this.estimate.packageReference)
                            await Http.put(route('api.v1.packages.update-status.byReference', this.estimate.packageReference), {status_id: 300})
                            window.location.reload(true);
                        }
                    })
                }
            }
            this.busy = false;
        },
    },
    async mounted() {
        this.estimate = this.item
    }

}
</script>
